<template functional>
  <h2 :class="['section__title', { '-align-left': props.alignLeft, '-flat': props.flat }]">
    <span class="section__title-underline"><slot /></span>
  </h2>
</template>

<script>
export default {
  name: 'ContentTitle',
  props: {
    alignLeft: { type: Boolean, default: false },
    flat: { type: Boolean, default: false }
  }
}
</script>
